import React from "react";
import { action, extendObservable } from "mobx";
import { observer } from "mobx-react";
import TextareaAutosize from "react-autosize-textarea";
import { injectIntl, intlShape } from "react-intl";
import PropTypes from "prop-types";
import { Popover, Button, Overlay } from "react-bootstrap";

import DeleteButton from "../common_components/DeleteButton";

@injectIntl
@observer
class Editable extends React.Component {
  constructor(props) {
    super(props);

    extendObservable(this, {
      showOptionPopover: false,
      showSuccess: false,
      textTooLarge: false
    });
  }

  render() {
    const {
      intl,
      value,
      canEdit,
      placeholder,
      lineThrough,
      showDelete,
      canDelete,
      maxLength,
      className
    } = this.props;
    const textStyle = { textDecoration: lineThrough ? "line-through" : null };
    const showButtonContainer = showDelete && canDelete;
    const deleteButtonClass = showButtonContainer
      ? "editable-container-with-buttons"
      : "";

    return (
      <div className={`editable-container ${deleteButtonClass} ${className}`}>
        <TextareaAutosize
          className="editable-text-area form-control"
          style={textStyle}
          ref={element => (this.textAreaComponent = element)}
          type="text"
          defaultValue={value}
          placeholder={placeholder}
          onBlur={this.finishEdit}
          onKeyDown={this.checkKey}
          onChange={this.handleChange}
          readOnly={!canEdit}
        />

        <div className=" editable-buttons-container">
          {this.renderDeleteButton()}
          {this.renderOptionButton()}
        </div>

        {this.showSuccess && (
          <div className="editable-check-mark-container">
            <i
              className="fa fa-check-circle"
              style={{ fontSize: "1.5em", color: "#1C8D8E" }}
            />
          </div>
        )}

        {this.textTooLarge && (
          <div style={{}}>
            <span className="fa fa-exclamation-circle" />
            {intl.formatMessage({ id: "note_text_too_large" })}
          </div>
        )}
        {/*{this.editing ? this.renderEdit() : this.renderValue()}*/}
      </div>
    );
  }

  // renderValue = () => {
  //     const {value, placeholder, lineThrough, canEdit} = this.props;
  //
  //     const textStyle = {textDecoration: lineThrough ? 'line-through' : null};
  //
  //     const valueOrPlaceholder = value.length > 0 ? value : placeholder;
  //
  //     return (
  //         <div className=" editable-div-value-container">
  //
  //
  //             <div style={textStyle}
  //                  onClick={canEdit ? this.edit : undefined}>
  //                 <Text>{valueOrPlaceholder}</Text>
  //             </div>
  //             <div className=" editable-buttons-container">
  //                 {this.renderDeleteButton()}
  //             </div>
  //
  //         </div>
  //     );
  // };
  //
  //
  // renderEdit = () => {
  //     return (
  //         <TextareaAutosize className=" editable-text-area-div-container"
  //                           type='text'
  //                           autoFocus={true}
  //                           defaultValue={this.props.value}
  //                           onBlur={null}
  //                           onKeyPress={this.checkEnter}
  //                           onClick={this.preventPropagation}
  //         />
  //     );
  // };

  // renderEditButton = () => {
  //     return (
  //         <button onClick={this.edit}
  //                 className=" editable-edit-button btn-transparent delete glyphicon glyphicon-pencil"/>
  //     )
  // };

  renderOptionButton = () => {
    const { showOptionButton, optionButtonText } = this.props;

    if (!showOptionButton) {
      return null;
    }

    return (
      <React.Fragment>
        <Button
          bsStyle="default"
          className="editable-option-button"
          onClick={this.toggleShowOptionPopover}
          ref={element => (this.optionButtonRef = element)}
        >
          <i className="fa fa-caret-down" />
        </Button>

        <Overlay
          show={this.showOptionPopover}
          onHide={() => (this.showOptionPopover = false)}
          rootClose
          target={this.optionButtonRef}
          placement="bottom"
        >
          <Popover id="editable-option-button-popover" className="react-board">
            <div className="editable-buttons-container">
              <Button
                bsStyle={"primary"}
                onClick={this.handleOptionButtonClick}
              >
                {optionButtonText}
              </Button>
            </div>
          </Popover>
        </Overlay>
      </React.Fragment>
    );
  };

  renderDeleteButton = () => {
    const { canDelete, showDelete, onDelete } = this.props;

    if (showDelete && canDelete) {
      return <DeleteButton onDelete={onDelete} />;
    }
  };

  // edit = (e) => {
  //     this.preventPropagation(e);
  //
  //     this.editing = true;
  // };

  checkKey = e => {
    const { value } = this.props;

    /*
        if (e.key === 'Enter' && !e.shiftKey) {
            this.preventPropagation(e);
            // this will trigger onBlur's finishEdit() method
            this.textAreaComponent.textarea.blur();
        }
        */
  };

  finishEdit = e => {
    const { value } = this.props;

    if (
      e.target.value.trim() &&
      value !== e.target.value &&
      !this.textTooLarge
    ) {
      this.props.onEdit(e.target.value);
      this.triggerSuccess();
    } else {
      e.target.value = value;
    }

    // this.editing = false;
  };

  handleChange = e => {
    if (e.target.value.length >= this.props.maxLength) {
      this.textTooLarge = true;
    } else {
      this.textTooLarge = false;
    }
  };

  preventPropagation = e => {
    e.preventDefault();
    e.stopPropagation();
  };

  // this is needed to prevent modal from close, it may be a bug of onKeyDown of TextareaAutosize
  escFunction = e => {
    const { value } = this.props;

    if (e.key === "Escape") {
      this.preventPropagation(e);
      e.target.value = value;
      e.target.blur();
    }
  };

  triggerSuccess = () => {
    this.showSuccess = true;
  };

  @action
  toggleShowOptionPopover = () => {
    this.showOptionPopover = !this.showOptionPopover;
  };

  handleOptionButtonClick = () => {
    const { onOptionButtonClick } = this.props;

    this.toggleShowOptionPopover();
    onOptionButtonClick();
  };

  componentDidMount() {
    this.textAreaComponent.textarea.addEventListener(
      "keydown",
      this.escFunction,
      true
    );
  }

  componentWillUnmount() {
    this.textAreaComponent.textarea.removeEventListener(
      "keydown",
      this.escFunction,
      true
    );
  }
}

Editable.propTypes = {
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  intl: intlShape.isRequired,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  canEdit: PropTypes.bool,
  canDelete: PropTypes.bool,
  showDelete: PropTypes.bool,
  showOptionButton: PropTypes.bool,
  optionButtonText: PropTypes.string,
  onOptionButtonClick: PropTypes.func,
  maxLength: PropTypes.number
};

export default injectIntl(Editable);
